module.exports = __webpack_public_path__ + "media/backgrounds/phone-bg-4ea83ac4.png";